module.exports = __webpack_public_path__ + "media/images/logo--icon-38408952bba9d5915ed0d8b06c4306e1.svg";